import { makeStyles } from '@material-ui/core/styles';

import { neutral, red } from 'shared/styles/colors';

export default makeStyles({
  btn: {
    minWidth: 'fit-content',
    padding: '0.5rem',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: neutral['80'],
    backgroundColor: neutral.white,
    borderRadius: '0.5rem',
    border: `1px solid ${neutral['20']}`,
    transition: 'all 300ms ease',
    '&.hasUnseenAlerts': {
      border: 'none',
      color: red['60'],
      backgroundColor: red['10'],
    },
    '&.pulsing': {
      animation: '$colorPulse 1.5s ease-in-out',
    },
  },
  badge: {
    top: '+0.25rem',
    right: '+0.25rem',
  },

  labelContainer: {
    maxWidth: 0,
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    transition: 'max-width 0.5s ease-in-out',
    '&.expanded': {
      maxWidth: '220px',
      marginLeft: '0.25rem',
    },
    '&.compact': {
      maxWidth: 0,
      marginLeft: 0,
    },
  },
  label: {
    margin: 0,
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    opacity: 0,
    whiteSpace: 'nowrap',
    transform: 'translateX(100%)',
    '&.show': {
      animation:
        '$slideIn 1s 0s forwards, $stay 3s 4s forwards, $slideOut 1s 5s forwards',
    },
  },

  // Animation COLOR_PULSE
  '@keyframes colorPulse': {
    '0%, 33.33%, 66.67%, 100%': {
      color: red['60'],
      backgroundColor: red['10'],
    },
    '16.67%, 50%, 83.33%': {
      color: neutral['80'],
      backgroundColor: neutral.white,
    },
  },
  // Animation SLIDE_IN
  '@keyframes slideIn': {
    '0%': {
      opacity: 0,
      transform: 'translateX(100%)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
  // Animation STAY
  '@keyframes stay': {
    '0%, 100%': {
      opacity: 1,
    },
  },
  // Animation SLIDE_OUT
  '@keyframes slideOut': {
    '0%': {
      opacity: 1,
      transform: 'translateX(0)',
    },
    '100%': {
      opacity: 0,
      transform: 'translateX(100%)',
    },
  },
});
